import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  SyncOutlined,
} from '@ant-design/icons';
import {
  GenerationOptionStatusEnum,
  GitlabPipelineStatusEnum,
} from 'osep-generator-service-client-v1';
import { StrykerAlertColor } from 'osep-react-antd';
import React from 'react';

function mapGenerationStatus(
  status: GenerationOptionStatusEnum | GitlabPipelineStatusEnum,
): {
  color: StrykerAlertColor;
  text: string;
  status: GenerationOptionStatusEnum;
  progressStatus: 'exception' | 'active' | 'success';
  tagColor: 'success' | 'processing' | 'error';
  tagIcon: React.ReactElement;
} {
  switch (status) {
    case GenerationOptionStatusEnum.Success:
      return {
        color: StrykerAlertColor.SUCCESS,
        text: 'SUCCESS',
        status,
        progressStatus: 'success',
        tagColor: 'success',
        tagIcon: <CheckCircleOutlined />,
      };
    case GenerationOptionStatusEnum.Running:
      return {
        color: StrykerAlertColor.INFO,
        text: 'RUNNING',
        status,
        progressStatus: 'active',
        tagColor: 'processing',
        tagIcon: <SyncOutlined spin />,
      };
    default:
      return {
        color: StrykerAlertColor.ERROR,
        text: 'ERROR',
        status,
        progressStatus: 'exception',
        tagColor: 'error',
        tagIcon: <CloseCircleOutlined />,
      };
  }
}

export default mapGenerationStatus;
